module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG6caad4959c577c6621dddf002edc963a.6caad495.png";